define('view/people/internal.associations.detail.view',['require','exports','module','uikit/uikit','backbone.radio','fukit/fukit','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),
      RolesHelper = require('fukit/fukit').RolesHelper,
      ROLES       = require('fukit/fukit').Roles,

  //behaviors
      AuthorizationBehavior = require('fukit/fukit').AuthorizationBehavior;

  // var ANY_UNIT_ROLE = [ROLES.UNIT_CREATE, ROLES.UNIT_READ, ROLES.UNIT_UPDATE, ROLES.UNIT_DELETE];
  // var CREATE_UPDATE_OPTIONS = [
  //   {
  //     filter: function() {
  //       var state = Radio.request('AppKit.controllerService', 'state');
  //
  //       return state.get('authorizationMode') === 'create';
  //     },
  //     message: function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.hasOnlyNamespacedRoles('PERSON_INTERNAL_AFFILIATION_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_UNIT_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       ANY_UNIT_ROLE,
  //       [ROLES.PERSON_PROFILE_UPDATE],
  //       [ROLES.PERSON_INTERNAL_AFFILIATION_CREATE]
  //     ]
  //   },
  //   {
  //     filter: function() {
  //       return true
  //     },
  //     message: function() {
  //       var readOnly = RolesHelper.hasOnlyNamespacedRoles('PERSON_PROFILE_', ['READ']) && RolesHelper.hasOnlyNamespacedRoles('PERSON_INTERNAL_AFFILIATION_', ['READ']) && RolesHelper.evaluateRoleArrayAgainstUserRoles(ANY_UNIT_ROLE);
  //
  //       return 'You do not have permission to edit this' + ((readOnly) ? ' page.' : '.');
  //     },
  //     roles: [
  //       ANY_UNIT_ROLE,
  //       [ROLES.PERSON_PROFILE_UPDATE],
  //       [ROLES.PERSON_INTERNAL_AFFILIATION_UPDATE]
  //     ]
  //   }
  // ];

  var AssociationsDetailPageView = UIKit.ItemView.extend({
    className: 'page',

    template: 'associations.detail.page',

    internalViewOptions: {
      appointmentFormView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
      },
      unitFormView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
        behaviors: {
          // AuthorizationBehavior: {
          //   visibleOnlyWhen: [
          //     {
          //       filter: function() {
          //         return true
          //       },
          //       roles: ANY_UNIT_ROLE
          //     }
          //   ],
          //   behaviorClass: AuthorizationBehavior
          // },
        },
      },
      unitId: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'relationships.unit.name',
          },
          behaviors: {
            // AuthorizationBehavior: {
            //   enableOnlyWhen: CREATE_UPDATE_OPTIONS,
            //   behaviorClass: AuthorizationBehavior
            // }
          },
        };
      },
      title: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'title',
          },
          behaviors: {
            // AuthorizationBehavior: {
            //   enableOnlyWhen: CREATE_UPDATE_OPTIONS,
            //   behaviorClass: AuthorizationBehavior
            // }
          },
        };
      },
      employeeId: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'employeeId',
          },
          behaviors: {
            // AuthorizationBehavior: {
            //   enableOnlyWhen: CREATE_UPDATE_OPTIONS,
            //   behaviorClass: AuthorizationBehavior
            // }
          },
        };
      },
    },

    onInjectedUnitFormView: function() {
      var unitDropdown = this.buildComponent({ name: 'unitId' });

      this.bindOption('model', 'model', this.unitFormView);
      this.unitFormView.addField({ text: 'Unit', required: true }, unitDropdown).parent();
    },

    onInjectedAppointmentFormView: function() {
      var titleInput = this.buildComponent({ name: 'title' });
      var employeeIDInput = this.buildComponent({ name: 'employeeId' });

      this.bindOption('model', 'model', this.appointmentFormView);
      this.appointmentFormView
        .addGroup()
        .addField({ text: 'Title', required: true }, titleInput)
        .parent()
        .addField({ text: 'Employee ID', required: true }, employeeIDInput)
        .parent()
        .parent();
    },
  });

  module.exports = AssociationsDetailPageView;
});

